import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import MainProvider from 'contexts/MainProvider';
import './index.css';
import 'leaflet/dist/leaflet.css';

window.addEventListener('error', (event) => {
  if (event.message.includes('ChunkLoadError') || event.message.includes('Loading chunk')) {
    const hasReloaded = sessionStorage.getItem('chunk-load-error-reloaded');
    if (!hasReloaded) {
      sessionStorage.setItem('chunk-load-error-reloaded', 'true');
      window.location.reload();
    }
  }
});

window.addEventListener('load', () => {
  sessionStorage.removeItem('chunk-load-error-reloaded');
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <MainProvider>
    <App />
  </MainProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
